import { defineMessages } from 'react-intl';

export const searchMetaScope = 'app.containers.Search.meta';

/**
 * Messages for the search page <title>/<meta description> and JSON-LD.
 * The french strings must stay identical to the historical hardcoded ones
 * (they are the live FR SEO surface).
 */
export const searchMetaMessages = {
  transportTypeTrain: {
    id: `${searchMetaScope}.transportTypeTrain`,
    defaultMessage: 'train',
    en: 'train',
    it: 'treno',
    es: 'tren',
    de: 'Zug',
    nl: 'trein',
  },
  transportTypeBus: {
    id: `${searchMetaScope}.transportTypeBus`,
    defaultMessage: 'bus',
    en: 'bus',
    it: 'autobus',
    es: 'autobús',
    de: 'Bus',
    nl: 'bus',
  },
  transportTypeCarpooling: {
    id: `${searchMetaScope}.transportTypeCarpooling`,
    defaultMessage: 'covoiturage',
    en: 'carpooling',
    it: 'carpooling',
    es: 'coche compartido',
    de: 'Mitfahrgelegenheit',
    nl: 'carpoolen',
  },
  transportTypeGeneric: {
    id: `${searchMetaScope}.transportTypeGeneric`,
    defaultMessage: 'train, bus et covoiturage',
    en: 'train, bus and carpooling',
    it: 'treno, autobus e carpooling',
    es: 'tren, autobús y coche compartido',
    de: 'Zug, Bus und Mitfahrgelegenheit',
    nl: 'trein, bus en carpoolen',
  },
  fromPrice: {
    id: `${searchMetaScope}.fromPrice`,
    defaultMessage: 'dès {price} euros',
    en: 'from {price} euros',
    it: 'da {price} euro',
    es: 'desde {price} euros',
    de: 'ab {price} Euro',
    nl: 'vanaf {price} euro',
  },
  priceRange: {
    id: `${searchMetaScope}.priceRange`,
    defaultMessage: 'Prix entre : {min}€ et {max}€',
    en: 'Prices between €{min} and €{max}',
    it: 'Prezzi tra {min}€ e {max}€',
    es: 'Precios entre {min}€ y {max}€',
    de: 'Preise zwischen {min}€ und {max}€',
    nl: 'Prijzen tussen €{min} en €{max}',
  },
  durationRange: {
    id: `${searchMetaScope}.durationRange`,
    defaultMessage: 'Durée : entre {min} et {max}',
    en: 'Duration: between {min} and {max}',
    it: 'Durata: tra {min} e {max}',
    es: 'Duración: entre {min} y {max}',
    de: 'Dauer: zwischen {min} und {max}',
    nl: 'Duur: tussen {min} en {max}',
  },
  dailyTrips: {
    id: `${searchMetaScope}.dailyTrips`,
    defaultMessage: 'Trajets quotidien : {count}',
    en: 'Daily trips: {count}',
    it: 'Viaggi giornalieri: {count}',
    es: 'Viajes diarios: {count}',
    de: 'Tägliche Verbindungen: {count}',
    nl: 'Dagelijkse ritten: {count}',
  },
  title: {
    id: `${searchMetaScope}.title`,
    defaultMessage:
      'Billet de {transportType} {origin} {destination} pas cher {price}',
    en: 'Cheap {transportType} ticket from {origin} to {destination} {price}',
    it: 'Biglietto {transportType} {origin} {destination} economico {price}',
    es: 'Billete de {transportType} {origin} {destination} barato {price}',
    de: 'Günstiges {transportType}-Ticket {origin} {destination} {price}',
    nl: 'Goedkoop {transportType}-ticket {origin} {destination} {price}',
  },
  descriptionEnd: {
    id: `${searchMetaScope}.descriptionEnd`,
    defaultMessage: 'Réservez le trajets le moins cher.',
    en: 'Book the cheapest trip.',
    it: 'Prenota il viaggio più economico.',
    es: 'Reserva el viaje más barato.',
    de: 'Buche die günstigste Verbindung.',
    nl: 'Boek de goedkoopste rit.',
  },
  productName: {
    id: `${searchMetaScope}.productName`,
    defaultMessage: 'Billet de {transportType} {origin} {destination}',
    en: '{origin} to {destination} {transportType} ticket',
    it: 'Biglietto {transportType} {origin} {destination}',
    es: 'Billete de {transportType} {origin} {destination}',
    de: '{transportType}-Ticket {origin} {destination}',
    nl: '{transportType}-ticket {origin} {destination}',
  },
};

export default defineMessages(searchMetaMessages);
